<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="onCancel()" title="cerrar">
      <span class="cross"></span>
      <span class="sr-only">{{ 'CERRAR' | translate }}</span>
    </a>
  </div>
  <div class="aviso">
    <div class="tituloSearch">
      {{ data.title | translate }}
    </div>
    <div class="faturacion-fila" *ngIf="data.message">
      <div class="row">
        {{ data.message | translate }}
      </div>
    </div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="cancelar"
            class="cancelar"
            (click)="onCancel()"
          >
            {{ (data.cancelText || 'NO') | translate }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="confirmar"
            class="pagar aceptar"
            (click)="onConfirm()"
          >
            {{ (data.confirmText || 'SI') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

